/* eslint-disable quotes */
import React from 'react';
import ReactDOM from 'react-dom';
import 'fontsource-roboto';
import { Provider } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App';

import store from './reducers/store';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#CD272F',
    },
    secondary: {
      main: '#808080',
    },
    background: {
      default: '#FFFFFF',
    },
  },
  typography: {
    p: {
      fontsize: 10,
    },
    h4: {
      fontSize: 30,
    },
    h6: {
      fontSize: 18,
      fontWeight: 100,
    },
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
